import { ApiKeyItemModel } from '@/services/apis/setting/module'
import sweep from '@/services/apis/sweep'
import {
  SweepAccountPagination,
  SweepNetwork,
  SweepNetworkInfo,
} from '@/services/apis/sweep/models'
import { useEffect, useState } from 'react'
import openApi from '@/services/apis/openApi'
import logger from '@/services/logger'
import {
  AutoSweepAddressBookListModel,
  AutoSweepRuleModel,
  WhiteListAuditStatusEnum,
} from '@/services/apis/policy/model'
import policy from '@/services/apis/policy'

export const useGetSweepNetworks = () => {
  const [isLoading, setLoading] = useState<boolean>(false)
  const [networks, setNetworks] = useState<SweepNetwork[]>([])
  useEffect(() => {
    setLoading(true)
    sweep
      .getSweepNetworkList()
      .then(res => {
        if (res.success) {
          setNetworks(res.data)
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])
  return {
    data: networks,
    isLoading,
  }
}

export const useGetSweepGray = () => {
  const [isOpened, setOpened] = useState(false)
  useEffect(() => {
    sweep.getSweepGray().then(res => {
      if (res.success) {
        setOpened(res.data)
      }
    })
  }, [])
  return isOpened
}

export const useGetSweepNetworkInfo = (networkKey?: string) => {
  const [networkInfo, setNetworkInfo] = useState<SweepNetworkInfo>()
  useEffect(() => {
    if (networkKey) {
      sweep.getSweepNetworkInfo({ networkKey }).then(res => {
        if (res.success) {
          setNetworkInfo(res.data)
        }
      })
    }
  }, [networkKey])

  return networkInfo
}

export const useGetApiCoSigner = () => {
  const [apiCoSigners, setApiCoSigners] = useState<ApiKeyItemModel[]>([])
  useEffect(() => {
    openApi.getApiCoSigner().then(res => {
      if (res.success) {
        setApiCoSigners(res.data)
      }
    })
  }, [])
  return apiCoSigners
}

const defaultPagination = {
  totalElements: 0,
  totalPages: 0,
  content: [],
  pageNumber: 0,
}

export const useFindSweepAccounts = (searchVal: string, coinKey?: string) => {
  const [isLoading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState<SweepAccountPagination>(defaultPagination)

  useEffect(() => {
    if (!coinKey) {
      logger.debug('coinKey为空，不获取sweepAccounts')
      return
    }
    setLoading(true)
    sweep
      .findSweepAccounts({
        coinKey,
        name: searchVal,
        pageNumber: currentPage,
      })
      .then(res => {
        if (res.success) {
          setPagination(res.data)
        }
      })
      .finally(() => setLoading(false))
  }, [coinKey, searchVal, currentPage])

  useEffect(() => {
    setCurrentPage(1)
  }, [searchVal, coinKey])
  return {
    data: pagination,
    setData: setPagination,
    isLoading,
    currentPage,
    setCurrentPage,
  }
}

export const useGetSweepWhiteList = (searchVal: string, blockchainTypeKey?: string) => {
  const [isLoading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState<AutoSweepAddressBookListModel>(defaultPagination)

  useEffect(() => {
    if (!blockchainTypeKey) {
      logger.debug('blockchainTypeKey为空，不获取sweep白名单')
      return
    }
    setLoading(true)
    policy
      .getAutoSweepAddressBookList({
        queryStr: searchVal,
        page: currentPage,
        auditStatus: WhiteListAuditStatusEnum.passed,
        type: 2,
        blockchainTypeKey,
      })
      .then(res => {
        if (res.success) {
          setPagination(res.data)
        }
      })
      .finally(() => setLoading(false))
  }, [searchVal, currentPage, blockchainTypeKey])

  useEffect(() => {
    setCurrentPage(1)
  }, [searchVal, blockchainTypeKey])
  return {
    data: pagination,
    isLoading,
    currentPage,
    setCurrentPage,
  }
}

export const useGetAutoSweepRuleList = (forceUpdate?: any) => {
  const [rules, setRules] = useState<AutoSweepRuleModel[]>()
  useEffect(() => {
    policy.getAutoSweepRuleList().then(res => {
      if (res.success) {
        setRules(res.data || [])
      }
    })
  }, [forceUpdate])
  return rules
}
